const routes = {
  index: "/",
  redirect: "",

  student: {
    login: "/",
    register: "/register",
    leaderboard: "/leaderboard",
    coursePlayer: "/course-player",
    quiz: (videoId = ":videoId") => `/${videoId}/quiz`,
  },

  admin: {
    login: "/admin/login",
    dashboard: "/admin/dashboard",
    videos: "/admin/videos",
    addVideo: "/admin/add-video",
    editVideo: (videoId = ":videoId") => `/admin/edit-video/${videoId}`,
    assignments: "/admin/assignments",
    addAssignment: "/admin/add-assignment",
    editAssignment: (assignmentId = ":assignmentId") =>
      `/admin/edit-assignment/${assignmentId}`,
    assignmentMark: "/admin/assignment-mark",
    quiz: "/admin/quiz",
    addQuiz: "/admin/add-quiz",
    editQuiz: (quizId = ":quizId") => `/admin/edit-quiz/${quizId}`,
  },
};

export default routes;
